<template>
    <vue-final-modal
        v-if="show"
        v-model="show"
        name="product-modal"
        classes="vizion-modal-container"
        content-class="vizion-modal-content"
    >

        <span class="vizion-modal-title">
            {{ textHeading }}
        </span>

        <div class="vizion-modal-body">
            <div class="vizion-modal-image">
                <img :src="cartItem.attributes.product_preview"
                     :alt="cartItem.name"
                >
            </div>

            <div class="vizion-modal-buttons">
                <a href="#"
                   rel="nofollow"
                   @click.prevent="show = false"
                   class="button purple">
                    {{ textContinueShopping }}
                </a>
                <a :href="routeToCart" class="button primary">
                    {{ textGoToCart }}
                </a>
            </div>
        </div>

    </vue-final-modal>
</template>

<script>
import { onMounted, ref, inject } from 'vue'

export default {

    props: {
        textHeading: {
            required: true,
                type: String
        },

        textContinueShopping: {
            required: true,
                type: String
        },

        textGoToCart: {
            required: true,
                type: String,
        },

        routeToCart: {
            required: true,
                type: String
        }
    },

    setup() {

        const show   = ref(false),
            cartItem = ref(null)

        const emitter = inject('emitter')

        onMounted( () => {
            emitter.on('product-added', (data) => {
                cartItem.value = data
                show.value     = true
            })
        })

        return {
            show,
            cartItem
        }
    }
}
</script>
